import type { VisibleFieldModel, VisibleFieldsEditModel } from 'shared/domain/visibleField/visibleFieldModel';
import type { EntityCollectionActions } from '../entityCollection';
import type { ActionsState, AsyncAction, DataActions, StoreData } from '../types';

export const visibleFieldActionNames = ['edit'] as const;

export type VisibleFieldActionName = (typeof visibleFieldActionNames)[number];

export type VisibleFieldActions = DataActions<VisibleFieldModel> & EntityCollectionActions<VisibleFieldModel>;

export type VisibleFieldAsyncActions = {
  /** Resolves once the server saved the edit and the fields were read again; rejects with its error. */
  edit: (visibleFieldsEdit: VisibleFieldsEditModel) => Promise<void>;
};

export type VisibleFieldStore = {
  data: StoreData<VisibleFieldModel>;
  actions: VisibleFieldActions;
  asyncActions: VisibleFieldAsyncActions;
  _actionStates: ActionsState<VisibleFieldActionName>;
};

export type EditVisibleFieldsAction = AsyncAction<[visibleFieldsEdit: VisibleFieldsEditModel], void>;
